import { useState } from "react";
import { Switch } from "@headlessui/react";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { setIsAdmin } from "../../../redux/reducers/user.reducer";
import ROUTE_CONSTANT from "../../../routes/routeconstants";
export default function AdminOrUserToggleButton() {
  const [enabled, setEnabled] = useState(false);
  const navigate = useNavigate();
  const isAdmin = useSelector((state) => state.user.isAdmin);
  const dispatch = useDispatch();

  const handleSwitchChange = (e) => {
    dispatch(setIsAdmin(e));
    // dispatch the action to update the isAdmin state
    if (e) {
      navigate(`${ROUTE_CONSTANT.HOME_ADMIN}`);
    } else {
      navigate(`${ROUTE_CONSTANT.HOME}`);
    }
  };

  return (
   <div className="flex flex-col items-center pr-0 lg:pr-4">
    <Switch
        checked={isAdmin !== undefined ? isAdmin : false}
        onChange={handleSwitchChange}
        className="relative inline-flex w-full h-6 shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out data-checked:bg-indigo-600"
      >
        <span className="sr-only">Use setting</span>
        <span
          className={`pointer-events-none relative inline-block size-6 transform rounded-full bg-white ring-0 shadow-sm transition duration-200 ease-in-out ${
            isAdmin ? "translate-x-9" : "translate-x-0"
          }`}
        >
          {/* Left Icon (Shown when off) */}
          {!isAdmin && (
            <span
              aria-hidden="true"
              className="absolute inset-0 flex size-full items-center justify-center transition-opacity duration-200 ease-in-out opacity-100"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="#F2C646"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-4"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
                />
              </svg>
            </span>
          )}

          {/* Right Icon (Shown when on) */}
          {isAdmin && (
            <span
              aria-hidden="true"
              className="absolute inset-0 flex size-full items-center justify-center opacity-100 transition-opacity duration-200 ease-in-out"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="#F2C646"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-4"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M11.42 15.17 17.25 21A2.652 2.652 0 0 0 21 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 1 1-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 0 0 4.486-6.336l-3.276 3.277a3.004 3.004 0 0 1-2.25-2.25l3.276-3.276a4.5 4.5 0 0 0-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437 1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008Z"
                />
              </svg>
            </span>
          )}
        </span>
      </Switch>
      <p className="mt-2 text-[7px] font-bold whitespace-nowrap text-black">Switch Account</p>
    </div>
  );
}
